export default {
  data () {
    return {
      selected: []
    }
  },
  computed: {
    selectableClass () {
      return (d, classes) => (Array.isArray(classes) ? classes : []).concat([{
        selected: this.selectIndex(d) > -1
      }])
    }
  },
  methods: {
    selectableClassStr (d, classes) {
      const classList = []
      this.selectableClass(d, classes).forEach(cls => {
        if (typeof cls === 'string') {
          classList.push(cls)
        } else {
          Object.keys(cls).filter(k => cls[k]).forEach(k => {
            classList.push(k)
          })
        }
      })
      return classList.join(' ')
    },
    deselectAll () {
      this.selected.splice(0)
    },
    deselect (d, quiet) {
      const index = this.selected.findIndex(s => this.selectDataKey(s) === this.selectKey(d))
      if (index > -1) {
        if (!quiet) {
          this.$emit('unselect', d)
        }
        this.selected.splice(index, 1)
      }
    },
    selectIndex (d) {
      return this.selected.findIndex(s => this.selectDataKey(s) === this.selectDataKey(d))
    },
    selectDataKey(d) {
      return this.selectKey(this.selectData(d))
    },
    selectKey (d) {
      return d
    },
    selectData (d) {
      return d
    },
    handleSelect (d) {
      const index = this.selectIndex(d)
      if (index >  -1) {
        this.selected.splice(index, 1)
        this.$emit('unselect', this.selectData(d))
      } else {
        this.selected.push(d)
        this.$emit('select', this.selectData(d))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/d3vue/mixins/selectable.js